import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { Autocomplete, Checkbox, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField } from "@mui/material";
import { IDataPesquisarBebidasCafe } from "../../types/api/cafe/pesquisar-bebidas-cafe";
import { onChangeMultipleValue } from "./helpers";

export default function SelectBebidaCafe({
    value,
    onChange,
    type = "single"
}: SelectSimpleApiQueryProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-bebidas-cafe"],
        queryFn: () => axiosClient.get("pesquisar-bebidas-cafe", {
            params: {
                limit: 50
            }
        })
    });
    const listData: IDataPesquisarBebidasCafe[] = data?.data.data || []
    //

    if (type === "single") return (
        <Autocomplete
            disablePortal
            disabled={isLoading}
            id="combo-box-demo"
            value={value as SingleValue}
            options={listData.map((i) => ({ label: i.bebida_nome, id: i.bebida_id }))}
            onChange={(_: any, newValue: SingleValue) => {
                onChange(newValue);
            }}
            renderInput={(params) => <TextField {...params} label={isLoading ? "Carregando" : "Bebidas"} fullWidth />}
        />
    )

    //type == multiple
    const valorFormatado = (value as TObjValue[]).map((item) => `${item.id},${item.label}`)
    
    const handleChangeMultipleValue = (event: SelectChangeEvent<string[]>) => {
        const valorFinal = onChangeMultipleValue(event.target.value as string[])
        onChange(valorFinal as MultipleValue)
    }
    //

    return (
        <FormControl fullWidth>
            <InputLabel id="bebida-cafe">{isLoading ? "Carregando" : "Bebidas"}</InputLabel>
            <Select
                labelId="bebida-cafe"
                id="demo-multiple-name"
                multiple
                disabled={isLoading}
                value={valorFormatado}
                onChange={handleChangeMultipleValue}
                input={<OutlinedInput label="Bebidas" />}
                renderValue={(selected) => selected.map(e => e.split(",")[1]).join(', ')}
            >
                <MenuItem value="NaN,Todos(as)">
                    <Checkbox checked={valorFormatado.indexOf("NaN,Todos(as)") > -1} />
                    Todos(as)
                </MenuItem>

                {[...listData].map((item) => {
                    const valorOption = `${item.bebida_id},${item.bebida_nome}`
                    return (
                        <MenuItem
                            key={item.bebida_id}
                            value={valorOption}
                        >
                            <Checkbox checked={valorFormatado.indexOf(valorOption) > -1} />
                            {item.bebida_nome}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

interface SelectSimpleApiQueryProps {
    type?: 'single' | 'multiple';
    value: SelectValue;
    onChange: (arg: SelectValue) => void;
}

type SelectValue = SingleValue | MultipleValue;

type SingleValue = TObjValue | null;
type MultipleValue = TObjValue[];

type TObjValue = { label: string, id: number }